export function reduceObject(obj) {
	return Object.entries(obj).reduce(
		(a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
		{},
	);
}

export function exists(value) {
	return value !== null && value !== undefined;
}
